module.exports = __webpack_public_path__ + "static/media/company1@2x.c0aaa94c.png";